import { quoteOrTabRemoved } from 'epic/workspace/common/tabs/tabsEpics/quoteOrTabRemoved';
import type { CostsAndCharges } from 'models/streaming';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map, mergeMap, take, takeUntil } from 'rxjs/operators';
import { costAndChargeReceived } from 'state/quotes/regulations/regulation.actions';
import { isQuoteTypeWithRegulation } from 'state/quotes/utils';
import type { EpicWithThunk } from 'state/state.common';
import { fatEventApiConnector } from 'utils/streaming/api';
import { costsAndCharges } from 'utils/streaming/messages';

// TODO catch Error in Epic
export function costsAndChargeEpic(): EpicWithThunk {
  return (action$, state$, { oldHttpClient, streaming }) =>
    action$.pipe(
      ofType('QUOTE_ACKED'),
      filter(x => x.workspace === 'dynamic' && isQuoteTypeWithRegulation(x.quoteType)),
      mergeMap(({ tabId, quoteId }) => {
        const quoteOrTabRemoved$ = quoteOrTabRemoved(action$, tabId, quoteId, state$);
        return costsAndCharges(streaming).pipe(
          filter(x => x.quoteId === quoteId),
          mergeMap(lightEvent =>
            fatEventApiConnector(oldHttpClient)
              .getFatEvent<CostsAndCharges>(lightEvent)
              .pipe(
                catchError(_ => EMPTY),
                map(costAndCharge => costAndChargeReceived('dynamic', tabId, quoteId, costAndCharge)),
              ),
          ),
          take(1),
          takeUntil(quoteOrTabRemoved$),
        );
      }),
    );
}
